import * as React from 'react';
import {Col} from 'react-bootstrap';
import OptionButton from '../OptionButton';
import {IProduct} from '../../../../../../data/api/models';
import * as ReactMarkdown from 'react-markdown';

interface IHazardOptionItem {
    key: string;
    name: string;
}

interface IHazardousPackSelectorProps {
    hazardousOptions: IHazardOptionItem[];
    selectedPackKey: string;
    isCalculating: boolean;
    product: IProduct;
    onSelectPack: (packKey: string) => void;
    channelKey: string;
    renderDefinition(name: string): any;
}

export default class HazardousPackSelector extends React.PureComponent<IHazardousPackSelectorProps> {
    private handleSelect = (packKey: string) => () => {
        this.props.onSelectPack(packKey);
    }

    public render() {
        const p = this.props;
        const product = p.product;

        if (!p.hazardousOptions || p.hazardousOptions.length === 0) {
            return null;
        }

        return (
            <div>
                {p.hazardousOptions.map((opt) => {
                    const packKey = opt.key;
                    const packName = opt.name;
                    const isBasePack = packName === 'Activity Pack 1';
                    const isSelected = p.selectedPackKey === packKey;
                    const channelKey = p.channelKey;
                    const def = product.metadata.definitions[packKey];
                    const renderDefinition = p.renderDefinition;
                    return (
                        <div key={packKey} style={{ marginBottom: '60px' }}>
                            <span style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                                {isBasePack
                                    ? <h2>Activity Pack 1</h2>
                                    : <h2>{packName}</h2>}
                                {
                                    channelKey === 'csis-b2c'
                                        ? renderDefinition(packKey)
                                        : ''
                                }
                            </span>
                            {channelKey !== 'csis-b2c' && (
                                <ReactMarkdown
                                    source={def}
                                    renderers={{
                                        link: ({ href, children }) => (
                                            <a href={href} target="_blank" rel="noopener noreferrer">
                                                {children}
                                            </a>
                                        ),
                                    }}
                                />
                            )}

                            <div
                                className="options-section"
                                style={{ border: 'none', marginBottom: '15px', marginLeft: '-15px' }}
                            >
                                <Col sm={4} className="option-question">
                                    <OptionButton
                                        disabled={!!p.isCalculating}
                                        isSelected={isSelected}
                                        selectedText={isBasePack ? 'Automatically Included' : 'Selected'}
                                        unselectedText={isBasePack ? 'Select Base Pack' : 'Select Pack'}
                                        onClick={this.handleSelect(packKey)}
                                        channelKey={channelKey}
                                    />
                                </Col>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/scenes/Quote/scenes/SchemeChoiceB/components/HazardousPackSelector/index.tsx